import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import pdfMake from "pdfmake/build/pdfmake";  
import pdfFonts from "pdfmake/build/vfs_fonts"; 
import {bocLogo} from '../../../assets/base64/boc-logo.js'
import {escienceLogo} from '../../../assets/base64/escience-logo.js'
import {BookingDetailPdf} from './booking-detail-pdf'
import { Observable } from 'rxjs';
import { HelperService } from 'src/app/services'
import { bookingType } from 'src/app/utils/constant/constants';
import { BookingDetailAirPdf } from './booking-detail-air-pdf';

pdfMake.vfs = pdfFonts.pdfMake.vfs;  

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(
    private helperService: HelperService
  ) { }

  /**
  * Identifies the Import Billing Invoice Pre Printed PDF Generator to be used based on the warehouse
  * that is selected (Pre Printed PDF Formats can be different in different warehouses)
  * 
  * @param data The data needed in the generation of PDF
  * @param selectedFont The font that will be used for the document
  * @param hblNumber The hblNumber needed to be showed in the document
  * @param sourceModule The module where the function has been called
  * 
  */


  generateContainerLabel(data) {
    // playground requires you to assign document definition to a variable called dd
    let fullName = this.helperService.formatName(data.recipientData.givenName, data.recipientData.middleName, data.recipientData.familyName, data.recipientData.suffix)
    let address = this.helperService.formatAddress(data.recipientData.address, data.recipientData.city, data.recipientData.province, 'Philippines', data.recipientData.zipPostalCode, data.recipientData.barangay)

    // let bocBase64 = this.toBase64(bocLogo)
    // console.log(bocBase64)

    var dd = {
      content: [
        {
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                { qr: data.bookingNumber },
                '',
                { image: bocLogo, width: 120, height: 120, },
              ],
            ]
          },
          layout: 'noBorders',
          margin: [0, 20, 0, 20]
        },
        { text: 'Balikbayan Box Label', style: 'header', alignment: 'center' },
        {
          table: {
            widths: [150, 20, '*'],
            body: [
              ['Booking Number', ':', data.bookingNumber],
              ['Recipient Name', ':', fullName],
              ['Destination', ':', address],
            ]
          },
          layout: 'noBorders',
          margin: [0, 20, 0, 20]
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*'],
            body: [
              [
                { text: `If you found this cargo, please return to: \n ${data.senderData.consolidator.name} \n ${data.senderData.consolidator.contactDetails}`, margin: 20, alignment: 'center' },
              ]
            ]
          },
          layout: {
            hLineStyle: function (i, node) {
              return {dash: {length: 6, space: 4}};
            },
            vLineStyle: function (i, node) {
              return {dash: {length: 6, space: 4}};
            },
          }
        },
        {
          table: {
            widths: ['*'],
            body: [
              [
                { text: 'Powered by:', alignment: 'center' },
              ],
              [
                { image: escienceLogo, width: 100, alignment: 'center' }
              ]
            ]
          },
          layout: 'noBorders',
          margin: [0, 20, 0, 20]
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        tableExample: {
          margin: [0, 20, 0, 20],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        },
      },
      defaultStyle: {
        // alignment: 'justify'
      },
      
    }
    pdfMake.createPdf(dd).download(`Balikbayan Box Label ${data.bookingNumber}.pdf`);
  }

  toBase64 = file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
  });

  generateBookingDetail(data, output_type, fileName) {
    // workaround for problem accessing data/helper on inner function.
    let dataHelper = this.helperService;
    let tempPickupDT = data.ofw_booking.pickup_preferred_date;
    let shipmentModeType: bookingType = data.ofw_booking.shipment_mode;
    let airDepartureDT = data.ofw_booking?.air_info?.departure_datetime;
    let airArrivalDT = data.ofw_booking?.air_info?.arrival_datetime;

    return new Observable((subsriber) => {
      try{
        prepareData();
        let bookingDetailPdf:any;
        if(shipmentModeType == bookingType.Sea){
          bookingDetailPdf = new BookingDetailPdf(
            data,
            {
              border:{
                top:0.25,
                left:0.25,
                bottom:0.25,
                right:0.25,
              },
              unit:'in'
            }
          )
        } else {
          bookingDetailPdf = new BookingDetailAirPdf(
            data,
            {
              border:{
                top:0.25,
                left:0.25,
                bottom:0.25,
                right:0.25,
              },
              unit:'in'
            }
          )
        }
        subsriber.next(bookingDetailPdf.generate(fileName,output_type))
        subsriber.complete()
      } catch(e) {
        subsriber.error(e)
      }
    })

    function prepareData() {
      if (data.ofw_booking_detail_list && data.ofw_booking_detail_list.length > 0){
        let total_booking_detail_value = 0

        _.forEach(data.ofw_booking_detail_list, (detail) => {

          // Do computations first
          detail['value_price'] = (detail.unit_price * detail.quantity)
          total_booking_detail_value = total_booking_detail_value + detail['value_price']

          // Do toFixed after. toFixed method converts number to string
          detail.unit_price = detail.unit_price.toFixed(2)
          detail['value_price'] = detail['value_price'].toFixed(2)

          detail.is_new = detail.is_new == 1 ? 'New' : 'Used'
        })

        data.ofw_booking['total_booking_detail_value'] = total_booking_detail_value.toFixed(2);
        data.ofw_booking['local_pickup_preferred_date_time'] = tempPickupDT ? dataHelper.getDateTimeLocal({ date: tempPickupDT }) : null;
        data.ofw_booking['air_local_departure_datetime'] = airDepartureDT ? dataHelper.getDateTimeLocal({ date: airDepartureDT, dateOnly: true }) : null;
        data.ofw_booking['air_local_arrival_datetime'] = airArrivalDT ? dataHelper.getDateTimeLocal({ date: airArrivalDT, dateOnly:true }) : null;
      }

    }
  }
  
}


const STRIPPING_TALLY_SHEET_CONFIGS = {
  LABEL: 'Stripping Tally Sheet',
  COORDINATES: {
    x_header: null,
    y_header: 20,
    x_initial: 15,
    y_initial: 35,
    y_increment: 5,
  },
  FONT_SIZE: {
    default: 16,
    small: 9,
    medium: 12,
    large: 26
  },
  FONT_TYPE: {
    default: "normal",
    bold: "bold",
    italic: "italic"
  }
}


const sample_data = {
  "ofw_booking": {
    "id": 114,
    "booking_number": "TRN-3B50FB0C0E0FF2-33",
    "ofw_id": 51,
    "ofw_passport_id": 36,
    "shipment_mode": "AIR",
    "total_value": 1,
    "consolidator_id": 1,
    "consolidator": {
      "id": 1,
      "code": "C01",
      "description": "Consolidator 1",
      "address": "Cavite",
      "contact_number": "69420",
      "email_address": "aaa@test.com"
    },
    "ask_for_pickup": 0,
    "pickup_preferred_date": "11-28-2022, 03:31:19",
    "pickup_contact_person": "",
    "pickup_contact_number": "",
    "pickup_email_address": null,
    "pickup_country": "Afghanistan",
    "pickup_state": "Badakhshan",
    "pickup_city": "Ashkāsham",
    "pickup_landmark": "Test Landmark",
    "pickup_address": "Test Address",
    "pickup_zipcode": "0000000",
    "pickup_sender_contact_number": "123213",
    "is_other_relationship": 0,
    "relationship_to_recipient": "Mother",
    "recipient_lastname": "Familyname",
    "recipient_middlename": "middlename",
    "recipient_firstname": "givenname",
    "recipient_suffixname": "",
    "recipient_contact_number": "09090909090",
    "recipient_email_address": "ryanA@adsa.com",
    "recipient_country": "Philippines",
    "recipient_state": "Abra",
    "recipient_city": "Boliney",
    "recipient_barangay": "Dumagas",
    "recipient_address": "Test address",
    "recipient_landmark": "test landmark",
    "recipient_zipcode": "4023",
    "recipient_geolocation": "",
    "current_year": 0,
    "request_submitted_date": null,
    "latest_status_id": 1,
    "status": {
      "code": "DRAFT",
      "description": "Draft"
    },
    "is_active": 1,
    "created_by": "ray.q",
    "created_date": "11-28-2022, 03:31:19",
    "modified_by": "ray.q",
    "modified_date": "12-05-2022, 08:57:50"
  },
  "ofw_booking_detail_list": [
    {
      "id": 243,
      "booking_id": 114,
      "item_description": "test item",
      "quantity": 69,
      "uom": "pc",
      "unit_price": 12,
      "is_new": 0,
      "hs_code": "CODE-01",
      "created_by": "ray.q",
      "created_date": "12-05-2022, 08:57:50",
      "modified_by": "ray.q",
      "modified_date": "12-05-2022, 08:57:50",
      "hs_code_description": {
        "id": 2,
        "code": "CODE-01",
        "description": "HS CODE 01"
      }
    }
  ]
}